import { render, staticRenderFns } from "./ChartCards.vue?vue&type=template&id=bfe3523e&scoped=true"
import script from "./ChartCards.vue?vue&type=script&lang=js"
export * from "./ChartCards.vue?vue&type=script&lang=js"
import style0 from "./ChartCards.vue?vue&type=style&index=0&id=bfe3523e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe3523e",
  null
  
)

export default component.exports